import { useEffect } from "react";
import { Outlet, useLocation } from "react-router";
import { useAuth } from "../context/AuthContext";
import { signInUrl } from "../lib/api";
import { IN_APP, tellAppReady } from "../lib/inApp";
import { FlashsuiteMenu, useFlashsuiteScript } from "./FlashsuiteMenu";
import { Logo } from "./Logo";

/**
 * The app for someone signed in to a business with its plan on. Signed out, Flashsuite signs them in and
 * sends them back here; with no plan on, Flashsuite's page takes it up (INTEGRATION.md section 17), never one of ours.
 * Inside the Flashsuite phone app nothing is sold, so there the page says only that Flashadz is not on, with
 * Flashsuite's menu to move to another business or app (flashsuite-phone docs/APP-MODE.md section 2).
 */
export function ProtectedRoute() {
  const { user, planAt, loading } = useAuth();
  const { pathname, search } = useLocation();
  const signedOut = !loading && !user;
  const notOn = !!user && !!planAt && IN_APP;
  useEffect(() => {
    if (signedOut) window.location.replace(signInUrl(pathname + search));
    else if (planAt && !IN_APP) window.location.replace(planAt);
  }, [signedOut, planAt, pathname, search]);
  if (notOn) return <NotOn />;
  if (loading || !user || planAt) {
    return (
      <div className="boot-splash">
        <Logo className="logo boot-logo" live />
      </div>
    );
  }
  return <Outlet />;
}

/** One plain sentence in the phone app, where a browser goes to Flashsuite's Start page. */
function NotOn() {
  const { businessName } = useAuth();
  useFlashsuiteScript();
  useEffect(tellAppReady, []);
  return (
    <div className="not-on">
      <div className="not-on-menu">
        <FlashsuiteMenu compact />
      </div>
      <Logo className="logo boot-logo" />
      <p>Flashadz is not on for {businessName || "this business"} yet.</p>
    </div>
  );
}
